import React from 'react';
import './Hero.css';

function Hero({ setCurrentSection }) {
  return (
    <div className="hero">
      <div className="hero-content">
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={() => setCurrentSection('wrappers')}>
            Shop Wrappers
          </button>
          <button className="btn btn-secondary" onClick={() => setCurrentSection('shoes')}>
            View Shoes
          </button>
          <button className="btn btn-secondary" onClick={() => setCurrentSection('bags')}>
            Browse Bags
          </button>
          <button className="btn btn-livestream" onClick={() => setCurrentSection('livestream')}>
            🔴 Join Live Market
          </button>
        </div>
      </div>
    </div>
  );
}

export default Hero;
